"use client";

import dynamic from "next/dynamic";

const BlockQuoteCarousel = dynamic(() => import("./BlockQuoteCarousel").then(mod => mod.BlockQuoteCarousel));

export const BlockQuoteCarouselLazy = (props: React.ComponentProps<typeof BlockQuoteCarousel>) => {
  return <BlockQuoteCarousel {...props} />;
};
